export function Stat({ label, value, hint }) {
  return (
    <div className="text-start flex flex-col items-center justify-start">
      <div className="muted-text">{label}</div>
      <div className="font-bold">
        {value !== undefined && value !== null && value !== "" ? value : hint}
      </div>
    </div>
  );
}
